import moment from 'moment';

import {setAvailabilityCookie} from '@/js/funnel/_mixins/menu-cookie';
const main = async () => {
    const [
        { default: Vue },
        {ModalPlugin},
        {AjaxMixin},
        {en, de},
        ErrorMessages,
        {ValidationProvider, ValidationObserver, extend, configure, localize},
        {required, required_if, email, alpha_num, min_value, max_value, regex, numeric, min, integer, digits},
        {emailTld},
        VueScrollTo,

    ] = await Promise.all([
        import(/* webpackChunkName: "vue" */ 'vue'),
        import(/* webpackChunkName: "bs-modal" */ 'bootstrap-vue'),
        import(/* webpackChunkName: "global-mixins-ajax" */ '@mymyMixins/ajax'),
        import(/* webpackChunkName: "vuejs-datepicker-locales" */ 'vuejs-datepicker/dist/locale'),
        import(/* webpackChunkName: "global-translations-validation" */ '@mymyTranslations/validation'),
        import(/* webpackChunkName: "vee-validate" */ 'vee-validate'),
        import(/* webpackChunkName: "vee-validate-rules" */ 'vee-validate/dist/rules'),
        import(/* webpackChunkName: "global-validators" */ '@mymyValidators'),
        import(/* webpackChunkName: "vue-scrollto" */ 'vue-scrollto'),
    ]);

    Vue.use(ModalPlugin);

    // for scrolling 
    Vue.use(VueScrollTo, {
        offset: -110,
    });

    // load our translated form error messages for this page's language
    localize(window.language, ErrorMessages.default[window.language]);

    // add our Vee Validate validators (email is already loaded)
    extend('required', required);
    extend('required_if', required_if);
    extend('alpha_num', alpha_num);
    extend('min_value', min_value);
    extend('max_value', max_value);
    extend('min', min);
    extend('email', email);
    extend('emailTld', emailTld);
    extend('numeric', numeric);
    extend('integer', integer);
    extend('digits', digits);
    extend('regex', regex);

    // tell Vee Validate which classes to apply when a field is valid/invalid, etc
    configure({ classes: { invalid: 'is-invalid' } });

    const vm = new Vue({
        name: 'AvailabilityFormMatrixBlock',
        el: '#availabilityForm',
        delimiters: ['[[', ']]'],
        mixins: [AjaxMixin],
        components: {
            'validation': ValidationProvider,
            'validation-observer': ValidationObserver,
            'datepicker': () => import(/* webpackChunkName: "vuejs-datepicker" */ 'vuejs-datepicker'),
        },
        data: {
            fields: {},
            success: false,
            successMessage: '',
            isLoading: false,
            serverErrors: [],
            // languages for date picker form field
            de: de,
            en: en,
        },
        created() {

        },
        computed: {
            datepickerOpenDate() {
                return moment(new Date()).add(3,'days').toDate();
            },
            disabledDates() {
                return {
                    to: moment(new Date()).add(2,'days').toDate(),
                    from: moment(new Date()).add(1,'year').toDate()
                }
            },
        },
        methods: {
            async onSubmit() {
                this.isLoading = true;

                // send the data to our controller (and include any extra data from the URL like UTM
                // params for marketing and tracking)
                const response = await this.makePostRequest(
                   'mymy/forms/submit-availability-form',
                   {
                       fields: this.fields,
                   }
                );

                if (response?.data?.success) {
                    this.success = true;
                    this.successMessage = response.data.message;
                    setAvailabilityCookie({
                        q: this.fields.guests,
                        p: this.fields.deliveryPostalCode,
                        d: this.fields.deliveryDate,
                    });
                    this.resetForm();
                    if (window.posthog) {
                        window.posthog.capture('user_availability_form_submit')
                    }
                }
                else if (response?.data?.error) {
                    this.success = false;
                    this.logErrors({message: [response.data.error]});
                }
                else if (response?.data?.errors) {
                    this.success = false;
                    this.logErrors(response.data.errors);
                }
                else {
                    this.success = false;
                    this.logErrors({message: ["There was an error"]});
                    if(window.Sentry) {
                        Sentry.captureMessage("Response not handled correctly")
                    }
                }
            },



            // HELPERS
            // =====================================================================================

            /**
             * METHOD: Reset the form to have no values in the fields.
             */
            resetForm() {
                for (let field in this.fields) {
                    this.fields[field] = '';
                }
                this.$refs.observer.reset();
                this.isLoading = false;
            },

            /**
             * METHOD: Handle Yii's errors coming back from the server.
             *
             * @param errors
             */
            logErrors(errors) {
                this.serverErrors = [];
                for (const erroredField in errors) {
                    for (const errorMessage of errors[erroredField]) {
                        this.serverErrors.push(errorMessage);
                    }
                }
                this.isLoading = false;
            },


            /**
             * METHOD: How should the datepicker field show its date?
             *
             * @param date
             * @returns {string}
             */
            customDatepickerFormatter(date) {
                return moment(date).format('D. MMM YYYY');
            },
        },
    });

    return vm;
};

// Execute async function
main().then((vm) => {
});

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
    module.hot.accept();
}